import * as React from "react";
import classnames from "classnames";
import { toast, ScrollIntoView, Link } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
/* empty css                           */
import { formatError } from "../../../../Util/Util/format-error.js";
const EmailSentConfirmation = React.forwardRef(
  ({
    title,
    firstParagraph,
    secondParagraph,
    thirdParagraph,
    resendLink,
    successMessage,
    className,
    onResend,
    email,
    error
  }, ref) => {
    const replaceEmail = (label, email2) => {
      return label && label.replace("{{email}}", email2) || "";
    };
    React.useEffect(() => {
      if (!error) {
        toast.success(successMessage);
      }
    }, [error, successMessage]);
    const sendEmail = () => {
      onResend({ email });
    };
    const formattedError = formatError(error);
    const errorKey = typeof formattedError === "string" ? formattedError : formattedError.join(" ");
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames("email-sent-confirmation", "myaccount__section", className),
        ref
      },
      /* @__PURE__ */ React.createElement(Heading, { variant: "medium" }, title),
      formattedError && /* @__PURE__ */ React.createElement(ScrollIntoView, { key: errorKey }, /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, formattedError)),
      /* @__PURE__ */ React.createElement(Text, null, replaceEmail(firstParagraph, email)),
      /* @__PURE__ */ React.createElement(Text, null, secondParagraph, " ", /* @__PURE__ */ React.createElement(Link, { onClick: sendEmail }, resendLink), " ", thirdParagraph)
    );
  }
);
export {
  EmailSentConfirmation as default
};
//# sourceMappingURL=EmailSentConfirmation.js.map
